import { render, staticRenderFns } from "./DatasetDownload.vue?vue&type=template&id=6592b1b6&"
import script from "./DatasetDownload.vue?vue&type=script&lang=js&"
export * from "./DatasetDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports